import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["playerCount", "startingLife", "playerRow", "playerName"]
  static values = { startingLifeTouched: Boolean }

  connect() {
    this.sync()
  }

  sync() {
    const count = this.selectedPlayerCount()

    this.playerRowTargets.forEach((row, index) => {
      const visible = index < count
      row.classList.toggle("d-none", !visible)
      row.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !visible
      })
    })

    if (!this.startingLifeTouchedValue) {
      this.startingLifeTarget.value = this.defaultStartingLife()
    }
  }

  markStartingLifeTouched() {
    this.startingLifeTouchedValue = true
  }

  selectedPlayerCount() {
    return parseInt(this.playerCountTarget.value, 10)
  }

  defaultStartingLife() {
    return this.selectedPlayerCount() === 2 ? "20" : "40"
  }
}
